import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["typeSize", "typographyComponent", "viewport", "children", "surface", "primaryColor"];
import React from 'react';
import PropTypes from 'prop-types';
import { Body as CoreBody } from '@vds-core/typography';
import { ColorTokens } from '@vds-tokens/color';
var propTypes = {
  /**
   * Children for the AccordionTitle can be any type.
   */
  children: PropTypes.node.isRequired,

  /**
   * @ignore
   * Pass in a subtitle component. Defaults to Body
   */
  typographyComponent: PropTypes.func,

  /**
   * @Ignore
   * Pass in a subtitle component size. Defaults to Body small 3.0
   */
  typeSize: PropTypes.oneOf(['small', 'large']),

  /**
   * Set the styling of the component to the desktop, tablet, or mobile size based on passed prop.
   * Desktop and tablet are the same size.
   */
  viewport: PropTypes.oneOf(['desktop', 'mobile', 'tablet']),

  /**
   * @ignore
   * primaryColor option for 1.0. Defaults to secondary for 3.0
   */
  primaryColor: PropTypes.bool,

  /**
   * @ignore
   */
  surface: PropTypes.oneOf(['light', 'dark'])
};
var defaultProps = {
  surface: 'light',
  typographyComponent: CoreBody,
  primaryColor: false
};

var AccordionSubTitle = function AccordionSubTitle(props) {
  var typeSize = props.typeSize,
      typographyComponent = props.typographyComponent,
      viewport = props.viewport,
      children = props.children,
      surface = props.surface,
      primaryColor = props.primaryColor,
      rest = _objectWithoutProperties(props, _excluded);

  var AccordionSubTitleStyled = typographyComponent;
  var isMobile = viewport === 'mobile';

  var _getBodySize = function _getBodySize() {
    if (typeSize) return typeSize; // Defaults to large for 1.0

    return isMobile ? 'small' : 'large'; // 3.0
  };

  var _getBodyColor = function _getBodyColor() {
    // use primary color if 1.0
    if (primaryColor) {
      return surface === 'dark' ? ColorTokens.elements.primary.ondark.value : ColorTokens.elements.primary.onlight.value;
    }

    return surface === 'dark' ? ColorTokens.elements.secondary.ondark.value : ColorTokens.elements.secondary.onlight.value;
  };

  return /*#__PURE__*/React.createElement(AccordionSubTitleStyled, _extends({
    surface: surface,
    viewport: viewport,
    color: _getBodyColor(),
    size: _getBodySize()
  }, rest), children);
};

AccordionSubTitle.propTypes = propTypes;
AccordionSubTitle.defaultProps = defaultProps;
AccordionSubTitle.displayName = 'AccordionSubTitle';
export default AccordionSubTitle;